import { type SourcingRun } from "@vidario/domain";
import { useMutation, useQueryClient, type UseMutationResult } from "@tanstack/react-query";

import { useVidarioClient } from "../client";
import { queryKeys } from "../queryKeys";

/** Admin-only: stop the job's running search (#88). Seeds the run cache so
 * the banner switches to „Suche wird gestoppt…" without waiting for a poll. */
export function useStopSourcing(): UseMutationResult<SourcingRun, Error, string> {
  const client = useVidarioClient();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (jobId) => client.stopSourcing(jobId),
    onSuccess: (run, jobId) => {
      qc.setQueryData(queryKeys.sourcingRun(jobId), run);
      qc.invalidateQueries({ queryKey: ["jobs"] });
    },
  });
}
